import { Alert, Table } from "@arco-design/web-react";
import { useQuery } from "@tanstack/react-query";
import { loadStayExternalRecords } from "../service/stayExternalImportService";

/** 酒店来源只读追溯，原始字段和变更前后完整保留。 */
export function StayExternalRecords({ spuId, active }: { spuId: string; active: boolean }) {
  const query = useQuery({
    queryKey: ["stay-external-records", spuId],
    queryFn: () => loadStayExternalRecords(spuId), enabled: active,
  });
  if (query.error) return <Alert type="error" content="来源记录读取失败，请重试"/>;
  return <Table rowKey="id" data={query.data ?? []} loading={query.isLoading}
    pagination={{ pageSize: 10 }} noDataElement="暂无外部来源记录"
    columns={[
      { title: "导入时间", dataIndex: "created_at" },
      { title: "携程 ID", dataIndex: "source_hotel_id" },
      { title: "批次", dataIndex: "batch_id" },
      { title: "操作人", dataIndex: "created_by" },
    ]}
    expandedRowRender={(row) => <pre style={{ whiteSpace: "pre-wrap" }}>{row.snapshot_text}</pre>}
  />;
}
